<template>
  <tab-layout>
    <li slot="tabHeading" class="nav-item">
      <a :class="['nav-link', selectedTab === 'details' ? 'active' : '']"
        href @click.prevent="selectedTab = 'details'"
        id="details-tab"
        data-toggle="tab"
        role="tab"
        aria-controls="details"
        :aria-selected="selectedTab === 'details' ? 'true' : 'false'">Details</a>
    </li>
    <li slot="tabHeading" class="nav-item">
      <a :class="['nav-link', selectedTab === 'financials' ? 'active' : '']"
         href @click.prevent="selectedTab = 'financials'" id="financials-tab"
         data-toggle="tab"
         role="tab"
         aria-controls="financials"
         :aria-selected="selectedTab === 'financials' ? 'true' : 'false'">Financials</a>
    </li>
    <li slot="tabHeading" class="nav-item">
      <a :class="['nav-link', selectedTab === 'committeeSecretariesList' ? 'active' : '']"
         href @click.prevent="selectedTab = 'committeeSecretariesList'" id="committeeSecretariesList-tab"
         data-toggle="tab"
         role="tab"
         aria-controls="committeeMembersList"
         :aria-selected="selectedTab === 'committeeSecretariesList' ? 'true' : 'false'">Secretaries</a>
    </li>
    <li slot="tabHeading" class="nav-item">
      <a :class="['nav-link', selectedTab === 'committeeMembersList' ? 'active' : '']"
         href @click.prevent="selectedTab = 'committeeMembersList'" id="committeeMembersList-tab"
         data-toggle="tab"
         role="tab"
         aria-controls="committeeMembersList"
         :aria-selected="selectedTab === 'committeeMembersList' ? 'true' : 'false'">Members</a>
    </li>
    <committee-edit
      v-if="selectedTab === 'details'"
      :memberDetails="memberDetails"
      :my="true"
      @renew="renew = true;selectedTab = 'membership'"
      slot="tabContent"
      :class="{ 'acting-readonly': $isActingForOtherCommittee }"
      class="tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active"
      id="details"
      role="tabpanel"
      aria-labelledby="details-tab" />
    <committee-details-members-status
      v-if="selectedTab === 'committeeMembersList' && memberDetails.committee_id"
      :committeeId="memberDetails.committee_id"
      :my="true"
      @renew="renew = true;selectedTab = 'committeeMembersList'"
      slot="tabContent"
      :class="{ 'acting-readonly': $isActingForOtherCommittee }"
      class="tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active"
      id="details"
      role="tabpanel"
      aria-labelledby="details-tab" />
    <committee-details-secretaries
      v-if="selectedTab === 'committeeSecretariesList' && memberDetails.committee_id"
      :committeeId="memberDetails.committee_id"
      slot="tabContent"
      :class="{ 'acting-readonly': $isActingForOtherCommittee }"
      class="tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active"
      id="committeeSecretariesList"
      role="tabpanel"
      aria-labelledby="committeeSecretariesList-tab" />
    <committee-profile-financials
      v-if="selectedTab === 'financials' && memberDetails.committee_id"
      :committeeId="memberDetails.committee_id"
      slot="tabContent"
      :class="{ 'acting-readonly': $isActingForOtherCommittee }"
      class="tab-pane col-12 col-xl-9 px-0 bg-white rounded mb-4 p-3 p-sm-4 show active"
      id="financials"
      role="tabpanel"
      aria-labelledby="financials-tab" />
  </tab-layout>
</template>

<script>
/* Use the "slot" attribute to match the heading and content
 * to their respective fields in the ListingLayout component. */
// 'My Profile'
import tabLayout from '@/components/TabLayout'
import GETSTORE from '@/store/memberProfileStore.js'
import CommitteeDetailsSecretaries from './components/CommitteeDetailsSecretaries'
import CommitteeDetailsMembersStatus from './components/CommitteeDetailsMembersStatus'
import CommitteeEdit from './CommitteeEdit'
import committeeProfileFinancials from "./../Profile/components/CommitteeProfileFinancials"

export default {
  name: 'CommitteeEditSecretary',
  mixins: [GETSTORE],
  components: {
    'tab-layout': tabLayout,
    'committee-edit': CommitteeEdit,
    'committee-details-secretaries': CommitteeDetailsSecretaries,
    'committee-profile-financials': committeeProfileFinancials,
    'committee-details-members-status': CommitteeDetailsMembersStatus
  },
  data() {
    return {
      selectedTab: this.tabSelect ? this.tabSelect : 'details',
      renew: this.renewing ? this.renewing : false,
      userID: localStorage.userID,
      userRole: localStorage.role
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/Committees/Edit/CommitteeEditSecretary.vue